import { css } from 'emotion';
import { gray1, gray3, gray7, weaveRed } from '@weave/platform-ui-components';

export const container = css`
  width: 350px;
  padding: 16px;
`;

export const nameField = css`
  width: 100%;
  margin-bottom: 16px !important;
`;

export const cardField = css`
  border-radius: 4px;
  border: 1px solid ${gray3};
  font-size: 13px;
  padding: 8px;
`;

export const errorText = css`
  font-size: 10px;
  color: ${weaveRed};
  padding-left: 8px;
`;

export const cardLogos = css`
  margin: 8px 0 16px;

  img {
    height: 25px;
    border: 1px solid ${gray1};
    border-radius: 4px;
    margin-right: 2px;
  }
`;

export const emailField = css`
  width: 100%;
  margin-bottom: 4px;
`;

export const buttonWrapper = css`
  position: absolute;
  bottom: 0;
  left: 0;
`;

export const modalStyles = css`
  width: 100%;
  text-align: center;

  p {
    text-align: left;
    margin: 0 auto 16px;
    font-size: 16px;
    color: ${gray7};
  }
  button {
    margin: auto;
  }
`;

export const modalButtons = css`
  display: flex;
  justify-content: space-evenly;
  margin-top: 16px;
`;

export const loader = css`
  width: 150px;
  display: block;
  margin: auto;
`;
